import SearchAddMore from './search-add-more';

export default SearchAddMore;
